<template>
    <transition name="toast-fade">
        <div class="toast-wrap" v-show="showing">{{text}}</div>
    </transition>
</template>

<script>
    const DEFAULT_DURATION = 3000;
    import Utils from './Utils';
    export default {
        name: 'toast',
        data() {
            return {
                text: '',
                showing: false,
                timer: null
            };
        },
        ready: function() {
            console.log('toast mounted...');
            // 将公共方法注册到Utils中
            Utils.register('toast', this.show);
        },
        methods: {
            show: function(text, duration, callback) {
                this.text = text;
                this.showing = true;
                if (this.timer) {
                    clearInterval(this.timer);
                }
                this.timer = setTimeout(() => {
                    this.showing = false;
                    if(typeof callback == 'function') {
                        callback()
                    }
                }, duration || DEFAULT_DURATION);
            }
        }
    }
</script>

<style type="sass">
    @import "../../sass/base/_abbrev.scss";

    .toast-wrap {
        position: fixed;
        top: 40%;
        left: 50%;
        transform: translate3d(-50%,0,0);
        -moz-transform: translate3d(-50%,0,0);
        -webkit-transform: translate3d(-50%,0,0);
        -o-transform: translate3d(-50%,-0,0);
        margin-left: auto;
        margin-right: auto;
        background-color: rgba(0, 0, 0, 0.7);
        color: #ffffff;
        text-align: center;
        padding: rem(30) rem(32);
        border-radius: rem(10);
        font-size:rem(28);
        line-height: 1.4;
        z-index: 10000;
    }
    .toast-fade-enter-active, .toast-fade-leave-active {
        transition: opacity .5s;
    }
    .toast-fade-enter, .toast-fade-leave-active {
        opacity: 0;
    }
</style>



// WEBPACK FOOTER //
// toast.vue?e402a880